import { Observable } from 'rxjs';
import {AccessTypeModel, FuncionalitiesUserAccessTypeModel} from '@src/core/domain/access/accessType.model';


export abstract class AccessRepository {
  abstract getAccess(): Observable<AccessTypeModel>;
  abstract getFuncionalitiesAccess(): Observable<FuncionalitiesUserAccessTypeModel>;
}
